<script>
  import {
    getTableColumnWidthHistory,
    setTableColumnWidthHistory
  } from './utils'

  function getComponentNameFromVnode (vnode) {
    return vnode.componentOptions.Ctor.options.name
  }

  function getElTable (el) {
    const { 
      componentOptions
    } = el

    if (getComponentNameFromVnode(el) === 'ElTable') {
      return el
    } else {
      const children = componentOptions ? componentOptions.children[0] : el.children[0]

      return getElTable(children)
    }
  }

  function loop (vnodes, cb) {
    vnodes.forEach(vnode => {
      const {
        componentOptions
      } = vnode
      const children = componentOptions && componentOptions.children

      if (componentOptions && getComponentNameFromVnode(vnode) === 'ElTableColumn') {
        cb(vnode)
      }
      
      if (children) {
        loop(children, cb)
      }
    })
  }

  export default {
    name: 'CacheColumnsWidth',
    functional: true,
    render (h, ctx) {
      const {
        children
      } = ctx

      const cacheKey = ctx.props.cacheKey

      if (cacheKey) {
        const table = getElTable(children[0])
        const tableEvents = table.componentOptions.listeners = Object.assign({}, table.componentOptions.listeners)
        const handleHeaderDragend = tableEvents['header-dragend']
        const cacheColumnsWidth = getTableColumnWidthHistory(cacheKey)
        const hasCache = !!Object.keys(cacheColumnsWidth).length

        tableEvents['header-dragend'] = function (newWidth, oldWidth, column, event) {
          if (handleHeaderDragend) handleHeaderDragend(newWidth, oldWidth, column, event)

          if (column.property) {
            cacheColumnsWidth[column.property] = newWidth
            setTableColumnWidthHistory(cacheKey, cacheColumnsWidth)
          }
        }

        if (hasCache) {
          const vnodes = table.componentOptions.children

          loop(vnodes, tableColumn => {
            const props = tableColumn.componentOptions.propsData
            const cacheWidth = cacheColumnsWidth[props.prop]

            if (cacheWidth) {
              props.width = cacheWidth
            }
          })
        }
      }
      
      return ctx.children
    }
  }
</script>